<template>
  <v-list dense style="width: 64px" :style="heightStyle" class="px-4 py-y">
    <template v-if="!closed">
      <v-list-item class="pa-0 ma-0 justify-center">
        <v-btn
          @click="setIsDrawing(!isDrawing)"
          class="floating-button"
          :class="isDrawing && 'background-primary'"
          :color="isDrawing ? 'black' : 'white'"
          icon
          ><v-icon class="button-icon">$iconDraw</v-icon></v-btn
        >
      </v-list-item>
      <v-list-item class="pa-0 pb-2 ma-0" style="min-height: 15px !important">
        <p class="text-center full-width">{{ $t("floorplan.lines") }}</p>
      </v-list-item>

      <v-list-item class="pa-0 ma-0 justify-center">
        <v-btn
          :disabled="corners.length === 0 || !isDrawing"
          class="floating-button"
          icon
          color="white"
          @click="undoLastCorner"
          ><v-icon class="button-icon">$iconUndo</v-icon></v-btn
        >
      </v-list-item>
      <v-list-item class="pa-0 ma-0" style="min-height: 15px !important">
        <p class="text-center full-width">{{ $t("floorplan.undo") }}</p>
      </v-list-item>
    </template>

    <template v-else>
      <v-list-item class="pa-0 ma-0 justify-center">
        <v-btn
          class="floating-button"
          icon
          color="white"
          @click="resetRoomCorners"
          ><v-icon class="button-icon">$iconDelete</v-icon></v-btn
        >
      </v-list-item>
      <v-list-item class="pa-0 ma-0 ml-n1" style="min-height: 15px !important">
        <p class="text-center full-width">{{ $t("floorplan.delete") }}</p>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "drawing-menu",
  computed: {
    ...mapState("roomStore", ["addingRoom", "isDrawing", "corners", "closed"]),
    heightStyle() {
      return `height: ${!this.closed ? "152" : "84"}px`;
    },
  },
  methods: {
    ...mapMutations("roomStore", [
      "undoLastCorner",
      "setIsDrawing",
      "resetRoomCorners",
    ]),
  },
};
</script>

<style lang="scss">
.floating-button {
  height: 32px !important;
  width: 32px !important;
}

.background-primary {
  background-color: var(--v-primary-base) !important;
}

.button-icon {
  height: 20px !important;
  width: 20px !important;
}

.full-width {
  width: 100% !important;
}
</style>
